export enum ROUTE_NAMES {
    AboutYou = "AboutYou",
    YourProperty = "YourProperty",
    YourCover = "YourCover",
    YourQuotes = "YourQuotes",
    Payment = "Payment",
    DirectDebit = "DirectDebit",
    ThankYou = "ThankYou",
    Error = "Error",
    SessionExpired = "SessionExpired",
    Declined = "Declined",
    PaymentFailed = "PaymentFailed",
    Marketing = "Marketing",
    QuoteConfirm = "QuoteConfirm",
    QuoteRecall = "QuoteRecall",
    MarketingPreferences = "MarketingPreferences",
    MarketingPreferencesLogin = "MarketingPreferencesLogin",
    MarketingPreferencesSuccess = "MarketingPreferencesSuccess"
}

export enum ROUTE_PATHS {
    CREATE = "/create",
    EDIT = "/edit",
    AboutYou = "about-you",
    YourProperty = "your-property",
    YourCover = "your-cover",
    YourQuotes = "/quote",
    Payment = "/quote/payment",
    DirectDebit = "/quote/direct-debit",
    ThankYou = "/quote/thank-you",
    Error = "/error",
    SessionExpired = "/session-expired",
    Declined = "/quote/declined",
    PaymentFailed = "/payment-failed",
    Marketing = "/quote/marketing",
    QuoteRecall = "/quote/recall",
    QuoteConfirm = "/quote/confirm",
    MarketingPreferences = "/quote/preferences",
    MarketingPreferencesLogin = "/quote/preferences/login",
    MarketingPreferencesSuccess = "/quote/preferences/success"
}
export enum FORM_MODE {
    CREATE = "Create",
    EDIT = "Edit"
}
export type FormMode = FORM_MODE;
